var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "-mt-32 updated-terms--section sm-md:-mt-20"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container max-w-2xl section--content fade-in-2"
  }, [_c('h1', {
    staticClass: "sm-md:h2"
  }, [_vm._v("Couple more things...")]), _vm._v(" "), _c('p', {
    staticClass: "my-4 text-lg leading-7"
  }, [_vm._v("Please review and acknowledge our updated terms below.")]), _vm._v(" "), _c('form', {
    staticClass: "flex flex-col mb-24",
    on: {
      "submit": _vm.submit
    }
  }, [_c('div', {
    staticClass: "mt-8 space-y-5 opacity-75 policies"
  }, [_c('div', {
    staticClass: "flex flex-row items-center space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPolicies.age_check,
      expression: "formPolicies.age_check"
    }],
    attrs: {
      "id": "ageCheck",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formPolicies.age_check) ? _vm._i(_vm.formPolicies.age_check, null) > -1 : _vm.formPolicies.age_check
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.formPolicies.age_check,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.formPolicies, "age_check", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.formPolicies, "age_check", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.formPolicies, "age_check", $$c);
        }
      }, () => _vm.policyChange('age_check')]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-lg",
    attrs: {
      "for": "ageCheck"
    }
  }, [_vm._v("I am at least 18 years old")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPolicies.e_sign,
      expression: "formPolicies.e_sign"
    }],
    attrs: {
      "id": "e_sign-input",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formPolicies.e_sign) ? _vm._i(_vm.formPolicies.e_sign, null) > -1 : _vm.formPolicies.e_sign
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.formPolicies.e_sign,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.formPolicies, "e_sign", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.formPolicies, "e_sign", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.formPolicies, "e_sign", $$c);
        }
      }, () => _vm.policyChange('e_sign')]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-lg",
    attrs: {
      "for": "e_sign-input"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tI have accessed, reviewed, and consent to Extra's\n\t\t\t\t\t\t\t"), _c('a', {
    staticClass: "text-lead btn-arrow",
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.showDisclosure('Extra_Electronic_Communications_Agreement')).apply(null, arguments);
      }
    }
  }, [_vm._v("E-SIGN Act Disclosure and Consent\n\t\t\t\t\t\t\t")])])]), _vm._v(" "), _vm.extraUser ? _c('div', {
    staticClass: "flex flex-row items-center space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPolicies.extra_credit_notice,
      expression: "formPolicies.extra_credit_notice"
    }],
    attrs: {
      "id": "extra_credit_notice-input",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formPolicies.extra_credit_notice) ? _vm._i(_vm.formPolicies.extra_credit_notice, null) > -1 : _vm.formPolicies.extra_credit_notice
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.formPolicies.extra_credit_notice,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.formPolicies, "extra_credit_notice", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.formPolicies, "extra_credit_notice", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.formPolicies, "extra_credit_notice", $$c);
        }
      }, () => _vm.policyChange('extra_credit_notice')]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-lg",
    attrs: {
      "for": "extra_credit_notice-input"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\tI agree to Extra's\n\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.showDisclosure('FCRA_Notice')).apply(null, arguments);
      }
    }
  }, [_vm._v("FCRA Notice")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row items-center pt-3 space-x-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formPolicies.military_lending,
      expression: "formPolicies.military_lending"
    }],
    staticClass: "optional",
    attrs: {
      "id": "military_lending-input",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.formPolicies.military_lending) ? _vm._i(_vm.formPolicies.military_lending, null) > -1 : _vm.formPolicies.military_lending
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.formPolicies.military_lending,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.formPolicies, "military_lending", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.formPolicies, "military_lending", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.formPolicies, "military_lending", $$c);
        }
      }, () => _vm.policyChange('military_lending')]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "text-lg",
    attrs: {
      "for": "military_lending-input"
    }
  }, [_c('span', {
    staticClass: "italic font-medium"
  }, [_vm._v("(if applicable)")]), _vm._v("\n\t\t\t\t\t\t\tI am covered by the\n\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.showDisclosure('Military_Lending')).apply(null, arguments);
      }
    }
  }, [_vm._v("Military Lending Act")])])])]), _vm._v(" "), _c('p', {
    staticClass: "my-12 text-lg leading-8 opacity-75"
  }, [_vm._v("\n\t\t\t\t\tBy clicking “Continue” I agree to Extra’s\n\t\t\t\t\t"), _c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.showDisclosure('Terms_of_Service')).apply(null, arguments);
      }
    }
  }, [_vm._v("Terms of Service")]), _vm._v("\n\t\t\t\t\t&\n\t\t\t\t\t"), _c('a', {
    staticClass: "text-lead btn-arrow",
    attrs: {
      "target": "blank"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return (() => _vm.showDisclosure('Privacy_Policy')).apply(null, arguments);
      }
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('button', {
    staticClass: "self-center text-lg",
    class: !_vm.formFilled || _vm.formProcessing ? 'opacity-50 disabled button--white' : 'button--mint button--filled',
    attrs: {
      "disabled": !_vm.formFilled || _vm.formProcessing,
      "type": "submit"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.formProcessing ? 'Hold tight...' : 'Continue') + "\n\t\t\t\t")])]), _vm._v(" "), _c('p', {
    staticClass: "my-12 text-base leading-8 opacity-75"
  }, [_vm._v("\n\t\t\t\tBanking services provided by Evolve Bank & Trust or Patriot Bank, N.A. (Member FDIC).\n\t\t\t")]), _vm._v(" "), _c('disclosure-footer')], 1)])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "max-w-2xl video-container"
  }, [_c('img', {
    staticClass: "-mb-6 media",
    attrs: {
      "src": require("assets/images/prequal.jpg"),
      "alt": "Extra debit card"
    }
  })]);
}];
export { render, staticRenderFns };